import React, { useState } from "react";

import { cloneDeep } from "lodash";

import CommonStyles from "./CommonStyles";

import { makeStyles } from '@mui/styles';
import { ButtonBase, Tooltip } from '@mui/material';

import LoaderNew from "./LoaderNew";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import ActionConfirmation from "./ActionConfirmation";
import PredicateChain from "./PredicateChain";
import JelListViewBtn from "../pages/UIEdit/components/JelListViewBtn";

import TrplSelect from "./TrplControls/TrplSelect";
import Filters from "./Filters";

const useStyles = makeStyles({
  row: ({ editable }) => ({
    padding: '1px 3px',
    margin: '2px',
    background: editable ? '#DBD6E5' : '#FFF',
    '&:hover': {
      boxShadow: '1px 3px 6px rgba(0, 0, 0, 0.05)',
    },
  }),
  rowContent: {
    display: 'flex',
    color: '#4E4C4C',
    padding: '10px',
    minHeight: '60px',
    position: 'relative',
    '&:hover': {
      '& .edit-icon': {
        display: 'flex',
      },
    },
  },
  subRowItemLine: ({ editable }) => ({
    width: '10px',
    paddingTop: '14px',
    marginLeft: '-15px',
    position: 'absolute',
    borderBottom: `1px solid ${editable ? '#FFFF' : '#b3bbf5'}`,
  }),
  editRowCol: {
    width: '40px',
    display: 'flex',
    flexShrink: '0',
    alignItems: 'center',
    paddingRight: '10px',
  },
  rowActionBtn: {
    textTransform: 'none',
  },
  deleteRowIcon: {
    fontSize: 16,
    marginLeft: 4,
    display: 'flex',
    color: '#878787',
    cursor: 'pointer',
  },
  rulesBlock: {
    minWidth: '400px',
    //border: '1px solid #b3bbf5',
    borderRadius: '5px',
    padding: '1px 3px',
    display: 'flex',
    background: '#ffff',
    flexDirection: 'column',
  },
  ...CommonStyles,
});

const ActionBtns = ({
  rule,
  classes,
  setRule,
  ruleData,
  setEditable,
  saveBtnLoaded,
  updateAccessRule,
  deleteAccessRule,
  setSaveBtnLoaded,
  setShowDeleteModal,
}) => {
  return (
  <div className={classes.justifyEnd} style={{ padding: '5px' }}>
    <ButtonBase
      className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr10}`}
      onClick={() => {
        if (rule.id) {
          setShowDeleteModal(true);
        } else {
          deleteAccessRule(rule);
          setEditable(false);
        }
      }}
    >
      <span>Delete</span>

      <DeleteIcon className={classes.deleteRowIcon} />
    </ButtonBase>
    <ButtonBase
      className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnEmpty} ${classes.mr20}`}
      onClick={() => {
        if (rule.id) {
          setEditable(false);
          setRule(ruleData);
        } else {
          deleteAccessRule(rule);
          setEditable(false);
        }
        setSaveBtnLoaded(true);
      }}
    >
      Cancel
    </ButtonBase>
    <ButtonBase
      className={`${classes.rowActionBtn} ${classes.btn} ${classes.btnNormal}`}
      onClick={() => {
        setSaveBtnLoaded(false)
        updateAccessRule({...rule}, (access_rule) => {
          setRule(access_rule);
          setSaveBtnLoaded(true);
          setEditable(false);
        });
      }}
    >
      {saveBtnLoaded === false ? (
        <LoaderNew style={{ height: '17px' }}/>
      ) : (
        'Save'
      )}
    </ButtonBase>
  </div>
  )

};


const RuleRow = ({
  id,
  jel,
  classes,
  deleted,
  ancestor,
  keyViewId,
  viewIndex,
  notEditable,
  onChangeModificator,
  modificator = 'WRITE',
}) => {
  const textColor = modificator === 'WRITE' ? 'green' : modificator === 'READ' ? 'blue' : 'red';

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      {ancestor && !deleted ?
        <PredicateChain
          mode='view'
          ancestor={ancestor}
          rst={id.includes('.') ? id.split('.') : id}
        />
      : <div>
        {deleted ?
          <span style={{ whiteSpace: 'nowrap', color: 'red' }}>
            Predicate {id}&nbsp; was removed from this view
          </span>
        :
          <JelListViewBtn
            viewData={{type: jel.type, title: `${jel.id} ${jel.title}`, id: jel.id}}
          />
        }
        </div>}
      <div className={`${classes.w100}`}>
        <TrplSelect
          margin='none'
          disabled={deleted || notEditable}
          value={modificator}
          style={{ color: textColor }}
          values={[
            'WRITE',
            'READ',
            'NONE',
          ]}
          onChange={(option) => {
            onChangeModificator(option.target.value, id, keyViewId, viewIndex)
          }}
        />
      </div>
    </div>
  )
}

const ViewAccessRule = ({
  jels,
  ruleData,
  setup_tbox,
  modifiable,
  updateAccessRule,
  getRulesInitials,
  deleteAccessRule,
  accessRulesNodes,
  addNodeToNodesData,
}) => {
  const [rule, setRule] = useState(() => cloneDeep(ruleData));
  const [editable, setEditable] = useState(ruleData.editable);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [saveBtnLoaded, setSaveBtnLoaded] = useState(true);

  const classes = useStyles({
    editable,
  });

  const onChangeModificator = (option, id, keyViewId, viewIndex) => {
    const ruleCopy = cloneDeep(rule);
    const view = ruleCopy.views[viewIndex];
    if (keyViewId) {
      view.chains[id] = option;
      if (checkIfChainsHaveSameModificator(view)) {
        for (let chain in view.chains) {
          if (view.chains[chain] !== '') view.chains[chain] = '';
        }
        view.default = option;
      }
    } else {
      for (let chain in view.chains) {
        if (view.chains[chain] !== '') view.chains[chain] = '';
      }
      view.default = option;
    }

    setRule(ruleCopy);
  };

  const checkIfChainsHaveSameModificator = (view) => {
    let defaultModificator = Object.values(view.chains)[0];
    let chainsWithSameModificator = 0;

    for (let chain in view.chains) {
      if (view.chains[chain] === defaultModificator) {
        chainsWithSameModificator++;
      } else {
        return false;
      }
    }
    if (view.chains && Object.keys(view.chains).length === chainsWithSameModificator) return true;
  }

  const setFiltersToState = (filters) => {
    setRule({
      ...rule,
      trigger: {
        ...rule.trigger,
        trpls: filters,
      }
    });
  };

  const getViewsIds = (views) => views.reduce(
    (array, currentView) => array.concat(currentView.id),
    []
  );

  const refreshRuleWithInitials = (data) => {

    const ruleCopy = cloneDeep(rule);
    if (!ruleCopy.trigger) {
      ruleCopy.trigger = {
        ancestor: jels.jelData[rule.views[0].id].concept,
        trpls: [],
      };
    }

    const previousViewsIds = getViewsIds(ruleCopy.views);

    const viewsCopy = data.views.map(view => {
      const previousViewData = rule.views.find(prevView => prevView.id === view.id)
      if (previousViewData) {
        const mergedView = {
          id: view.id,
          default: previousViewData.default,
          chains: {},
          deletedChains: {},
        };

        for (let chain in view.chains) {
          if (previousViewData.chains && Object.keys(previousViewData.chains).includes(chain)) {
            mergedView.chains[chain] = previousViewData.chains[chain];
          } else {
            mergedView.chains[chain] = view.chains[chain];
          }
        }

        for (let chain in previousViewData.chains) {
          if (!Object.keys(view.chains).includes(chain)) mergedView.deletedChains[chain] = previousViewData.chains[chain];
        }
        return mergedView;

      } else {
        return view;
      }
    });

    const thisViewsIds = getViewsIds(viewsCopy);

    const missingViews = previousViewsIds.filter(viewId => !thisViewsIds.includes(viewId));

    missingViews.length && missingViews.forEach(viewId => {
      const missingView = (rule.views.find(view => view.id === viewId));
      missingView.deleted = true;
      viewsCopy.push(missingView)
    })

    ruleCopy.views = viewsCopy;
    ruleCopy.missingViews = missingViews;

    setRule(ruleCopy);
  };

  const mainViewId = rule.views.length && rule.views[0].id;
  const mainViewTitle = jels.jelData[mainViewId] && jels.jelData[mainViewId].title;

  const deleteRuleModal = {
    contentText: 'Delete access rule with',
    contentBoldText: `id: ${rule && rule.id} to view: ${mainViewId} ${mainViewTitle}?`,
    open: showDeleteModal,
  };

  console.log(rule)

  return (
    <React.Fragment>
      <ActionConfirmation
        modalData={deleteRuleModal}
        acceptHandler={() => {
          deleteAccessRule(rule);
          setShowDeleteModal(false);
          setEditable(false);
        }}
        onClose={() => setShowDeleteModal(false)}
      />

      <div className={classes.row}>
        {editable ? (
          <ActionBtns
            rule={rule}
            classes={classes}
            setRule={setRule}
            ruleData={ruleData}
            setEditable={setEditable}
            saveBtnLoaded={saveBtnLoaded}
            updateAccessRule={updateAccessRule}
            deleteAccessRule={deleteAccessRule}
            setSaveBtnLoaded={setSaveBtnLoaded}
            setShowDeleteModal={setShowDeleteModal}
          />
        ) : null}
        <div className={classes.rowContent}>
          <div className={`${classes.mr10}`} style={{ width: '40px' }}>{rule.id}</div>
          {/* {rule.views && rule.views.length > 1 &&
           <div className={`${classes.mt20}`} style={{ borderLeft: `1px solid ${editable ? '#FFFF' : '#b3bbf5'}` }}></div>
          }  */}
          <div style={{ marginLeft: '-12px' }}>
            {rule.views.map((view, viewIndex) => {
              const jel = jels.jelData[view.id];

              return (
                <div
                  key={viewIndex}
                  className={`${classes.rulesBlock} ${viewIndex !== 0 ? classes.ml20 : ''} ${viewIndex !== 0 ? classes.mt5 : ''}`}
                >
                  {/* {viewIndex !== 0 ?
                    <div className={classes.subRowItemLine}></div>
                  : null} */}
                  {rule.missingViews && rule.missingViews.length && rule.missingViews.includes(view.id) ?
                    <span style={{ color: 'red' }}>View id : {view.id} was removed from this rule main form</span>
                  : jel ?
                    <React.Fragment key={viewIndex}>
                      <RuleRow
                        jel={jel}
                        id={view.id}
                        classes={classes}
                        notEditable={!editable}
                        viewIndex={viewIndex}
                        modificator={view.default}
                        onChangeModificator={onChangeModificator}
                      />
                      {view.chains && Object.keys(view.chains).map((chain, index) => {
                        return (
                          <RuleRow
                            key={index}
                            id={chain}
                            classes={classes}
                            keyViewId={view.id}
                            notEditable={!editable}
                            viewIndex={viewIndex}
                            ancestor={jel.concept}
                            modificator={view.chains[chain] || view.default}
                            onChangeModificator={onChangeModificator}
                          />
                        )
                      })}
                      {view.deletedChains && Object.keys(view.deletedChains).length
                        ? Object.keys(view.deletedChains).map((deletedChain, deletedChainIndex) => {
                        return (
                          <RuleRow
                            deleted={true}
                            classes={classes}
                            id={deletedChain}
                            keyViewId={view.id}
                            key={deletedChainIndex}
                            modificator={view.deletedChains[deletedChain] || view.default}
                          />
                        )
                      }) : null}
                    </React.Fragment>
                  : <span style={{ color: 'red' }}>View id : {view.id} not found</span>}
                </div>
              )
            })
            }
          </div>

          {rule.trigger && rule.trigger.ancestor ?
            <div style={{ display: 'inline-flex' }}>
              <PlayArrowIcon style={{ fill: '#C4C4C4', transform: 'rotate(180deg)', margin: '5px' }}/>
              <Filters
                defaultBg={true}
                ancestor={rule.trigger.ancestor}
                callbacks={{
                  setFiltersToParentState: setFiltersToState,
                  onFiltersSearchNodeCb: addNodeToNodesData,
                }}
                useChain
                isEvent
                nodes={accessRulesNodes}
                notEditableGraphTrigger
                graphTriggerAncestor={setup_tbox[rule.trigger.ancestor]}
                mode={editable ? 'edit' : 'show'}
                initialFilters={(ruleData.trigger && ruleData.trigger.trpls) || []}
              />
            </div>
          : null}

          <div className={classes.editRowCol}>
            {!editable && modifiable ? (
              <Tooltip
                title="Edit"
                placement="top"
                classes={{
                  tooltip: classes.muiTooltip,
                }}
              >
                <EditIcon
                  className={classes.ml20}
                  onClick={() => {
                    setEditable(true);
                    getRulesInitials(rule.views[0].id, refreshRuleWithInitials)
                  }}
                />
              </Tooltip>
            ) : null}
          </div>
        </div>
        {editable ? (
          <ActionBtns
            rule={rule}
            classes={classes}
            setRule={setRule}
            ruleData={ruleData}
            setEditable={setEditable}
            saveBtnLoaded={saveBtnLoaded}
            updateAccessRule={updateAccessRule}
            deleteAccessRule={deleteAccessRule}
            setSaveBtnLoaded={setSaveBtnLoaded}
            setShowDeleteModal={setShowDeleteModal}
          />
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default ViewAccessRule;
